module.exports = __webpack_public_path__ + "static/media/ic-criar-conta.7a112743.svg";